import React, { FC } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import LeftMenu from "../LeftMenu";
import FirstEducation from "./ui/General/Tabs/GeneralData";
import Surveys from "./ui/Surveys";

const url = process.env.REACT_APP_API_URL + "api/Child/api/Child/GetchildFullInfo";

const mockMenuItems: {
  [key: string]: JSX.Element;
} = {
  GeneralInformation: <FirstEducation/>,
  Surveys: <Surveys/>,
};

const SelectedEmployee: FC<{
  handleMenuItem: (menuItem: string) => void;
  selectedEmployees: {
    birthdate: string;
    id: number;
    name: string;
    patronimyc: string;
    phoneNumber: string;
    surname: string;
  }[];
  tab: number;
  menuItem: string;
}> = ({ handleMenuItem, selectedEmployees, tab, menuItem }) => (
  <Box display="flex">
    <LeftMenu handleMenuItem={handleMenuItem} />
    <Box display="flex" flexDirection="column" margin="8px">
      <Box display="flex" marginBottom="16px">
        <Typography marginRight="8px">
          {selectedEmployees[tab - 1]?.surname}
        </Typography>
        <Typography marginRight="8px">
          {selectedEmployees[tab - 1]?.name}
        </Typography>
        {/* <Typography marginRight="8px">
          {selectedEmployees[tab - 1]?.Patronymic}
        </Typography>
        <Typography marginRight="8px">
          {selectedEmployees[tab - 1]?.WorkPosition}
        </Typography>
        <Typography marginRight="8px">
          {selectedEmployees[tab - 1]?.WorkType}
        </Typography> */}
      </Box>
      {mockMenuItems[menuItem]}
    </Box>
  </Box>
);

export default SelectedEmployee;
